import { render, staticRenderFns } from "./itemsByCategory.vue?vue&type=template&id=2e139022&scoped=true"
import script from "./itemsByCategory.vue?vue&type=script&lang=js"
export * from "./itemsByCategory.vue?vue&type=script&lang=js"
import style0 from "./itemsByCategory.vue?vue&type=style&index=0&id=2e139022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e139022",
  null
  
)

export default component.exports